import React from 'react';

interface SwitchProps {
  checked: boolean;
  onChange?: (checked: boolean) => void;
  onCheckedChange?: (checked: boolean) => void;
  label?: string;
  disabled?: boolean;
  className?: string;
}

export const Switch: React.FC<SwitchProps> = ({ checked, onChange, onCheckedChange, label, disabled, className = '' }) => {
  const handleChange = (newChecked: boolean) => {
    if (disabled) return;
    if (onChange) onChange(newChecked);
    if (onCheckedChange) onCheckedChange(newChecked);
  };

  return (
    <label className={`inline-flex items-center cursor-pointer ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${className}`}>
      <div className="relative">
        <input
          type="checkbox"
          className="sr-only"
          checked={checked}
          onChange={(e) => handleChange(e.target.checked)}
          disabled={disabled}
        />
        <div 
          className={`block w-10 h-6 rounded-full transition-colors ${checked ? 'bg-os-primary' : 'bg-slate-300'}`}
        />
        <div 
          className={`absolute left-1 top-1 bg-white w-4 h-4 rounded-full transition-transform ${checked ? 'transform translate-x-4' : ''}`}
        />
      </div>
      {label && <span className="ml-3 text-sm font-medium text-slate-700">{label}</span>}
    </label>
  );
};
